import { useConfigurationSelector } from "@redux/reducers/appConfig";
import {
  useBusinessModelSelector,
  useFinanceSimulationSelector,
} from "@redux/reducers/deal";
import { useIsKeyAccount } from "@redux/reducers/auth";
import { getSolJourneyConfigForJourney } from "@shared/v2/lib/getSolJourneyConfigForJourney";
import { computeAvailableRegistrationMethods } from "@lib/computeAvailableRegistrationMethods";

export const useConfiguredRegistrationMethods = () => {
  const configuration = useConfigurationSelector();
  const businessModel = useBusinessModelSelector();
  const financeSimulation = useFinanceSimulationSelector();
  const isKeyAccount = useIsKeyAccount();

  const { vehicleRegistration } = getSolJourneyConfigForJourney(
    financeSimulation.journey,
    businessModel,
    configuration
  );

  return computeAvailableRegistrationMethods(vehicleRegistration, undefined, {
    isKeyAccount,
  });
};
